<template>
  <LightControls></LightControls>
</template>

<script>
import LightControls from "@/components/LightControls";

export default {
  name: "App",
  components: {
    LightControls,
  },
};
</script>

<style>
html {
  background-color: black;
  color: azure;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: azure;
  margin-top: 60px;
}
</style>
